import { FirebaseApp } from "firebase/app";
import {
  type Auth,
  type OAuthProvider,
  type ActionCodeSettings,
  type UserCredential,
  getAuth,
  OAuthProvider as FirebaseOAuthProvider,
  signInWithPopup as firebaseSignInWithPopup,
  sendSignInLinkToEmail as firebaseSendSignInLinkToEmail,
  isSignInWithEmailLink as firebaseIsSignInWithEmailLink,
  signInWithEmailLink as firebaseSignInWithEmailLink,
  connectAuthEmulator as firebaseConnectAuthEmulator,
} from "firebase/auth";

/**
 * Production implementation of FirebaseAuthAdapter that delegates to actual Firebase functions.
 */
export class FirebaseAuthAdapter {
  getAuth(app: FirebaseApp): Auth {
    return getAuth(app);
  }

  createOAuthProvider(providerId: string): OAuthProvider {
    return new FirebaseOAuthProvider(providerId);
  }

  signInWithPopup(
    auth: Auth,
    provider: OAuthProvider,
  ): Promise<UserCredential> {
    return firebaseSignInWithPopup(auth, provider);
  }

  sendSignInLinkToEmail(
    auth: Auth,
    email: string,
    config: ActionCodeSettings,
  ): Promise<void> {
    return firebaseSendSignInLinkToEmail(auth, email, config);
  }

  isSignInWithEmailLink(auth: Auth, link: string): boolean {
    return firebaseIsSignInWithEmailLink(auth, link);
  }

  signInWithEmailLink(
    auth: Auth,
    email: string,
    link: string,
  ): Promise<UserCredential> {
    return firebaseSignInWithEmailLink(auth, email, link);
  }

  connectAuthEmulator(auth: Auth, url: string): void {
    firebaseConnectAuthEmulator(auth, url);
  }
}
